import { render, staticRenderFns } from "./IconChevronRight.vue?vue&type=template&id=11af8b14&"
import script from "./IconChevronRight.vue?vue&type=script&lang=js&"
export * from "./IconChevronRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports